var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main_center" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "searchBox",
            {
              attrs: { dialogVisible: _vm.moreSearchItem, title: "更多筛选" },
              on: {
                "update:dialogVisible": function ($event) {
                  _vm.moreSearchItem = $event
                },
                "update:dialog-visible": function ($event) {
                  _vm.moreSearchItem = $event
                },
                dialogCancle: _vm.dialogCancle,
              },
            },
            [
              _c(
                "div",
                { staticClass: "search-drawer" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.form, "label-position": "top" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "组织机构名称：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入内容搜索",
                            },
                            model: {
                              value: _vm.form.orgName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "orgName", $$v)
                              },
                              expression: "form.orgName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "部门名称：" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                clearable: "",
                                filterable: "",
                                multiple: "",
                                placeholder: "请选择",
                              },
                              model: {
                                value: _vm.form.handleOrgName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "handleOrgName", $$v)
                                },
                                expression: "form.handleOrgName",
                              },
                            },
                            _vm._l(_vm.departmentOptions, function (item) {
                              return _c("el-option", {
                                key: item.data.id,
                                attrs: {
                                  label: item.data.deptName,
                                  value: item.data.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "人员名称：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              clearable: "",
                              placeholder: "请输入内容搜索",
                            },
                            model: {
                              value: _vm.form.handleUserName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "handleUserName", $$v)
                              },
                              expression: "form.handleUserName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "统计时间：" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "end-placeholder": "结束日期",
                              format: "yyyy-MM-dd",
                              "range-separator": "至",
                              "start-placeholder": "开始日期",
                              type: "daterange",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.datetimerange,
                              callback: function ($$v) {
                                _vm.datetimerange = $$v
                              },
                              expression: "datetimerange",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "数据所属部门：" } },
                        [
                          _c("select-depart-tree", {
                            ref: "selectDepartTreeRef",
                            attrs: {
                              type: "2",
                              modelValue: _vm.form.superviseDeptCodeList,
                              isMultiple: true,
                            },
                            on: {
                              "update:modelValue": function ($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "superviseDeptCodeList",
                                  $event
                                )
                              },
                              "update:model-value": function ($event) {
                                return _vm.$set(
                                  _vm.form,
                                  "superviseDeptCodeList",
                                  $event
                                )
                              },
                              handleDeptType: (val) => _vm.changeDept(val, "5"),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "search-drawer__footer" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: { click: _vm.searchBtn },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { plain: "", size: "small" },
                          on: { click: _vm.refresh },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { staticClass: "search-content" }, [
            _c(
              "div",
              { staticClass: "mainBtn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { plain: "", size: "small", type: "primary" },
                    on: { click: _vm.exportTable },
                  },
                  [_vm._v("导出")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "searchBtn" },
              [
                _c("span", { staticClass: "label-form" }, [
                  _vm._v("组织机构名称："),
                ]),
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: { clearable: "", placeholder: "请输入内容搜索" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.searchBtn.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.form.orgName,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "orgName", $$v)
                    },
                    expression: "form.orgName",
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "12px" },
                    attrs: { size: "small", type: "primary" },
                    on: { click: _vm.searchBtn },
                  },
                  [_vm._v("搜索")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: {
                      icon: "el-icon-arrow-down",
                      size: "mini",
                      type: "text",
                    },
                    on: {
                      click: function ($event) {
                        _vm.moreSearchItem = true
                      },
                    },
                  },
                  [_vm._v("更多搜索")]
                ),
                _c("el-divider", { attrs: { direction: "vertical" } }),
                _c("el-button", {
                  attrs: { icon: "el-icon-refresh", type: "text" },
                  on: { click: _vm.refresh },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dataListLoading,
                  expression: "dataListLoading",
                },
              ],
              ref: "multipleTable",
              staticClass: "table-content",
              attrs: {
                data: _vm.tableData,
                "header-cell-style": this.$globalGrayTableHeaderStyle,
                height: _vm.tableMaxHeight,
                stripe: "",
                border: "",
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "",
                  type: "index",
                  align: "center",
                  label: "序号",
                  width: "60",
                  index: _vm.getRowsIndex,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  "header-align": "center",
                  label: "所属组织机构名称",
                  prop: "handleOrgName",
                  width: "200",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "所属部门名称",
                  "min-width": "120",
                  prop: "handleDeptName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "办结人员姓名",
                  "min-width": "120",
                  prop: "handleUserName",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "参与办结项目(宗标段)",
                  "min-width": "160",
                  prop: "bidCount",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.bidCount + "宗"))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "办结次数",
                  "min-width": "120",
                  prop: "finishCount",
                  sortable: "",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.finishCount + "次")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "超时次数",
                  "min-width": "120",
                  prop: "timeoutCount",
                  sortable: "",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.timeoutCount + "次")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "超时率",
                  "min-width": "120",
                  prop: "timeoutRate",
                  sortable: "",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  "header-align": "center",
                  label: "平均超时时长",
                  "min-width": "130",
                  prop: "averageTimeout",
                  sortable: "",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  fixed: "right",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.routerDetail(scope.row, "detail")
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next",
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              total: _vm.total,
              "current-page": _vm.pageIndex,
            },
            on: {
              "size-change": _vm.sizeChangeHandle,
              "current-change": _vm.currentChangeHandle,
            },
          }),
        ],
        1
      ),
      _c("detailList", {
        ref: "detailListRef",
        attrs: { dialogVisible: _vm.detailListDialog },
        on: {
          "update:dialogVisible": function ($event) {
            _vm.detailListDialog = $event
          },
          "update:dialog-visible": function ($event) {
            _vm.detailListDialog = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }